import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: '#00AEEF',
        secondary: '#262626',
        tertiary: '#2193C3',
        accent: '#FAB040',
        error: '#D2232A',
        info: '#6F7073',
        success: '#7ABF49',
        warning: '#D94848',
        charcoal: '#262626',
        Red: '#ff0000',
        Blue: '#0000ff',
        Yellow: '#FFDB4D',
        Green: '#4DB84D',
        Black: '#000000',
      },
      light: {
        primary: '#2193C3',
        secondary: '#00AEEF',
        tertiary: '#2193C3',
        accent: '#FAB040',
        error: '#D2232A',
        info: '#6F7073',
        success: '#7ABF49',
        warning: '#D94848',
        charcoal: '#262626',
        Red: '#ff0000',
        Blue: '#0000ff',
        Yellow: '#FFDB4D',
        Green: '#4DB84D',
        Black: '#000000',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
